import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataActivity } from '../../features/Activity/Activity';
import Card from './Card';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import ArrowRight, { ArrowLeft } from '../../Icons/Icon';
import { useTranslation } from 'react-i18next';
import { SeeMore } from '../../Buttons/Buttons';
import getDirctionLang from '../../Actions/getDirctionLang';
import Loading from '../Loading';

function ActivityPage() {
    const dispatch = useDispatch();
    const { i18n, t } = useTranslation();

    useEffect(() => {
        dispatch(fetchDataActivity({ perPage: 6 }));
    }, [dispatch, i18n.language]);

    const { activities,loading } = useSelector((state) => state.activity);
    const isRtl = getDirctionLang();
    if(loading) return <Loading/>
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1, transition: { duration: 1 } }}
            className='mx-auto w-full lg:w-10/12 xl:w-10/12 2xl:w-9/12 md:p-10 my-3 mt-5'
        >
            <div className='flex justify-center items-center text-4xl font-bold  my-4'>
                <p>{t("latestNews")}</p>
            </div>

            {
                activities.length > 0 && (
                    <Swiper
                        key={i18n.language}
                        slidesPerView={1}
                        spaceBetween={20}
                        grabCursor={true}
                        centeredSlides={true}
                        //   grabCursor={true}
                        breakpoints={{
                            640: { slidesPerView: 2, spaceBetween: 20 },
                            768: { slidesPerView: 2, spaceBetween: 10 },
                            1024: { slidesPerView: 2, spaceBetween: 20 },
                            1280: { slidesPerView: 3, spaceBetween: 20 },
                       
                         
                        }}
                        modules={[Navigation, Autoplay]}
                        loop={activities?.length >= 3} // Only enable loop if enough items
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        dir={isRtl ? "rtl" : "ltr"}
                        navigation={{
                            nextEl: isRtl ? ".prev" : ".next",
                            prevEl: isRtl ? ".next" : ".prev",
                            clickable: true,
                        }}
                        className="mySwiper "
                    >
                        {activities?.map((activity) => (
                            <SwiperSlide key={activity.id} className='py-6  '>
                                <Link to={`/activity/${activity.id}`} className='flex justify-center'>
                                    <Card i18n={i18n} t={t} activity={activity} />
                                </Link>
                            </SwiperSlide>
                        ))}
                        <ArrowRight />
                        <ArrowLeft />
                    </Swiper>)
            }

            <div className="flex justify-center mt-4">

                <SeeMore link={"/activity"} />
            </div>
        </motion.div>
    );
}

export default ActivityPage;